import { Injectable, InjectionToken, Injector, Type, inject } from '@angular/core';

import { ProductService } from './product.service';

/**
 * @whatItDoes Combines root injector and lazy loaded product injector.
 *
 * @description
 *
 * This can be used to simplify getting of (multi) providers from both root and product injectors.
 * This should only be necessary in shared components (vanilla/labelhost).
 *
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class ProductInjector {
    private readonly injector = inject(Injector);
    private readonly productService = inject(ProductService);

    get<T>(token: Type<T> | InjectionToken<T>, notFoundValue?: T): T {
        let value: T | undefined;

        if (!this.productService.current.isHost) {
            value = this.productService.current.injector.get(token, undefined);
        }

        return value || this.injector.get(token, notFoundValue);
    }

    getMultiple<T>(token: Type<T[]> | InjectionToken<T[]>): T[] {
        const value = this.injector.get<T[]>(token, []);

        if (this.productService.current.isHost) {
            return value;
        }

        const productValues = this.productService.current.injector.get<T[]>(token, []);

        return value.concat(productValues);
    }
}
